import { NgModule } from '@angular/core';

import { SharedModule }                          from '../shared/shared.module';
import { VendorPaymentEmailRemittanceComponent } from './vendor-payment.email-remittance.component';

@NgModule({
  declarations: [
    VendorPaymentEmailRemittanceComponent
  ],
  entryComponents: [
    VendorPaymentEmailRemittanceComponent
  ],
  imports: [
    SharedModule
  ]
})
export class VendorPaymentsModule {}
